let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../../../utils/FormUtils");
let createStandardEventForm = require("../../createStandardEventForm");
let buildNDiffVideoCoaching = require('./buildNDiffVideoCoaching');

module.exports = createStandardEventForm({
	eventToInitialValues(event){
		return {
			participants:        esUtils.getIn(event, ["key_values", "PARTICIPANTS"]),
			individual_sessions: esUtils.getIn(event, ["key_values", "INDIVIDUAL_SESSIONS"]),
			team_sessions:       esUtils.getIn(event, ["key_values", "TEAM_SESSIONS"])
		};
	},
	buildSchema(){
		return {
			participants: {
				type: "text",
				label: "participants",
				validate: FormUtils.v.positive_integer
			},
			individual_sessions: {
				type: "text",
				label: "individual sessions",
				validate: FormUtils.v.positive_integer
			},
			team_sessions: {
				type: "text",
				label: "team sessions",
				validate: FormUtils.v.positive_integer
			}
		};
	},
	confirmMessageBeforeSave(old_event, new_event){
		//check if the new_event will cause data to be lost
		let has_data_loss = buildNDiffVideoCoaching(_.object(_.map(["PARTICIPANTS", "INDIVIDUAL_SESSIONS", "TEAM_SESSIONS"], function(key){
			return [key, esUtils.toInt(new_event.key_values && new_event.key_values[key])];
		})), old_event.VideoCoaching).has_data_loss;

		if(!has_data_loss){
			return;//no data will be lost with this change, so nothing to report
		}

		//Ask the user if they are sure
		return "This change will cause some coaching sessions to be DELETED. Continue?";
	},
	writeInputDataToEvent(data, event){
		if(!_.isPlainObject(event.key_values)){
			event.key_values = {};
		}
		event.key_values.PARTICIPANTS        = esUtils.toInt(data.participants);
		event.key_values.INDIVIDUAL_SESSIONS = esUtils.toInt(data.individual_sessions);
		event.key_values.TEAM_SESSIONS       = esUtils.toInt(data.team_sessions);

		event.VideoCoaching = buildNDiffVideoCoaching({
			PARTICIPANTS: event.key_values.PARTICIPANTS,
			INDIVIDUAL_SESSIONS: event.key_values.INDIVIDUAL_SESSIONS,
			TEAM_SESSIONS: event.key_values.TEAM_SESSIONS
		}, event.VideoCoaching).VideoCoaching;
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/coaching/CoachingFields.js